// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"265680be","537":"75d576c2"}[chunkId] + ".chunk.js";
};